module.exports = __webpack_public_path__ + "static/scale-model-of-rockhaven-in-glendale-california-1dca253c6525cf9d782df1e24b220ae0.png";